module.exports = __webpack_public_path__ + "static/media/cover-photo-web.37c11270.png";